import React from "react";
import Shake from "react-reveal/Shake";
import TeamCard from "../../components/team-card/team-card.component";
import Footer from "../../components/footer/footer.component";
import teamBackground from "../../assets/teamBack.png";
import team from "../../team";

import { Link } from "react-router-dom";

const Team = () => {
  return (
    <div>
      <section
        className="relative bg-cover bg-center bg-no-repeat h-[500px] flex items-center justify-center text-center"
        style={{
          backgroundImage: `url(${teamBackground})`, // replace with actual image path
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#2F1893]/80 to-[#000000]/80"></div>

        {/* Content */}
        <div className="relative z-10 text-white max-w-2xl px-4">
          <h2 className="text-4xl font-bold mb-4">
            Building Success Through Talent & Innovation
          </h2>
          <p className="text-lg text-[#FFFFFFE5]">
            Discover our pool of skilled professionals and explore the
            innovative projects we have delivered for clients across diverse
            industries.
          </p>
        </div>
      </section>

      <section className="mb-20 py-10 relative">
        <div className="container mx-auto px-8 md:px-0">
          <Shake>
            <p className="capitalize text-[#000D83] text-4xl font-medium text-center">
              our <span className="text-[#EFA632]">team</span>
            </p>
          </Shake>
          <div className=" justify-center flex">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 lg:gap-20 md:gap-10 gap-8 mt-12">
              {team.map((member) => (
                <Link
                  key={member.id}
                  // to={`/team/${member.name}`}
                  to={`/team/${member.name.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <TeamCard
                    photo={member.image}
                    name={member.name}
                    job={member.job}
                    key={member.id}
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Team;
